export var SPECS;
(function (SPECS) {
    SPECS["USE_LIGHTBOXES"] = "specs.stores.UseLightboxes";
    SPECS["ShouldUseOnlyBaseUrlAsOrigin"] = "specs.stores.ShouldUseOnlyBaseUrlAsOrigin";
    SPECS["ShouldUseOnlyPlatformExperiments"] = "specs.stores.ShouldUseOnlyPlatformExperiments";
    SPECS["IncreaseGqlGetLimit"] = "specs.stores.increaseGqlGetLimit";
    SPECS["ShouldForceNavigateToProductPage"] = "specs.stores.shouldForceNavigateToProductPage";
    SPECS["UsePrefixForRouterNavigationToProductPage"] = "specs.stores.UsePrefixForRouterNavigationToProductPage";
    SPECS["FixProductPageUrlsForRouterPage"] = "specs.stores.FixProductPageUrlsForRouterPage";
    SPECS["NavigateToCartWhenCallShowMiniCart"] = "specs.stores.NavigateToCartWhenCallShowMiniCart";
    SPECS["AddProjectionsTYPQuery"] = "specs.ecom.AddProjectionsTYPQuery";
    SPECS["OrdersModifiers"] = "specs.ecom.OrdersModifiers";
    SPECS["StopCallingGetClientConfigInCartIcon"] = "specs.ecom.StopCallingGetClientConfigInCartIcon";
    SPECS["StopUsingPaymentMethodsInCart"] = "specs.ecom.StopUsingPaymentMethodsInCart";
    SPECS["DontUseLineItemEnricherInCartAndCheckout"] = "specs.ecom.DontUseLineItemEnricherInCartAndCheckout";
    SPECS["AlwaysSendCurrencyHeader"] = "specs.ecom.AlwaysSendCurrencyHeader";
    SPECS["UseSessionStorageForCartCache"] = "specs.ecom.UseSessionStorageForCartCache";
    SPECS["ClearSessionStorageOnReload"] = "specs.ecom.ClearSessionStorageOnReload";
    SPECS["SessionStorageWithTTL"] = "specs.ecom.SessionStorageWithTTL";
    SPECS["DeprecateCartActions"] = "specs.ecom.DeprecateCartActions";
})(SPECS || (SPECS = {}));
export var BI_STOREFRONT_VIEW_MODE;
(function (BI_STOREFRONT_VIEW_MODE) {
    BI_STOREFRONT_VIEW_MODE["SITE"] = "site";
    BI_STOREFRONT_VIEW_MODE["PREVIEW"] = "preview";
    BI_STOREFRONT_VIEW_MODE["EDITOR"] = "editor";
})(BI_STOREFRONT_VIEW_MODE || (BI_STOREFRONT_VIEW_MODE = {}));
export var BI_PRODUCT_OPTION_TYPE;
(function (BI_PRODUCT_OPTION_TYPE) {
    BI_PRODUCT_OPTION_TYPE["COLOR"] = "color";
    BI_PRODUCT_OPTION_TYPE["LIST"] = "list";
})(BI_PRODUCT_OPTION_TYPE || (BI_PRODUCT_OPTION_TYPE = {}));
export var BI_PRODUCT_OPTION_ACTION;
(function (BI_PRODUCT_OPTION_ACTION) {
    BI_PRODUCT_OPTION_ACTION["CHECKED"] = "checked";
    BI_PRODUCT_OPTION_ACTION["UNCHECKED"] = "unchecked";
})(BI_PRODUCT_OPTION_ACTION || (BI_PRODUCT_OPTION_ACTION = {}));
export var ONE_HUNDRED_THOUSAND = 100000;
export var DEFAULT_CART_OPTIONS = { withShipping: false, withTax: false };
export var VIEW_MORE_OPTIONS_URL_FRAGMENT = 'view-more-options';
export var SecondaryEvents = {
    GetGQLRequest: 'CurrentCart.GetGQLRequest',
    GetRequest: 'CurrentCart.GetRequest',
    RefreshRequest: 'CurrentCart.RefreshRequest',
    UpdateQuantityRequest: 'CurrentCart.UpdateQuantityRequest',
    RemoveItemRequest: 'CurrentCart.RemoveItemRequest',
    UpdateBuyerNoteRequest: 'CurrentCart.UpdateBuyerNoteRequest',
    OnLoginStartRequest: 'CurrentCart.OnLoginStartRequest',
    OnLoginFinishRequest: 'CurrentCart.OnLoginFinishRequest',
    ApplyCouponRequest: 'CurrentCart.ApplyCouponRequest',
    RemoveCouponRequest: 'CurrentCart.RemoveCouponRequest',
    SetAddressRequest: 'CurrentCart.SetAddressRequest',
    SelectShippingOptionRequest: 'CurrentCart.SelectShippingOptionRequest',
    AddToCurrentCart: 'CurrentCart.AddToCurrentCart',
    ActionResponse: 'CurrentCart.ActionResponse',
    EstimateCurrentCartTotals: 'CurrentCart.EstimateCurrentCartTotals',
    Updated: 'CurrentCart.Updated',
    CreateCheckoutRequest: 'CurrentCart.CreateCheckoutRequest',
    HEALTH_CHECK: 'CurrentCart.HEALTH_CHECK',
    ACK: 'CurrentCart.ACK',
};
export var MiniCartEvents = {
    LoadedWithoutData: 'Minicart.LoadedWithoutData',
    OnInitialData: 'Minicart.OnInitialData',
};
export var DEFAULT_CURRENCY_HEADER = 'DEFAULT';
var ONE_MINUTE = 60 * 1000;
export var CACHE_TTL_MS = 10 * ONE_MINUTE;
//# sourceMappingURL=constants.js.map